import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { HttpRequestService } from 'src/app/Services/Http/http-request.service';
import { PropertiesService } from 'src/app/Services/Properties/properties.service';
import { SearchService } from 'src/app/Services/search.service';

@Component({
  selector: 'app-employee-asset',
  templateUrl: './employee-asset.component.html',
  styleUrls: ['./employee-asset.component.css']
})
export class EmployeeAssetComponent implements OnInit {
  subscription: Subscription;
  @Output() searchItem: EventEmitter<any> = new EventEmitter();
  searchInvoiceAdapter: any;
  constructor(private httpRequestService:HttpRequestService,
    private searchService: SearchService, 
    private router: Router,private property: PropertiesService) {
      this.subscription = searchService.searchRefreshEvt$.subscribe(() => {
        this.getGridData();
      });
     }

  ngOnInit() {
    this.getGridData();
  }

  ngAfterViewInit(): void {
    this.getGridData();
  }

  searchInvoiceColumns: any[] =
  [
    {
      text: 'S.No', width: '5%', sortable: false, menu: false, cellsrenderer: function (row, cell, value) {
        return '<div style="text-align: center; margin-top: 10px;">' + (1 + row) + '</div>';
      }
    },
    { text: 'EmployeeID', datafield: 'EmployeeID', width: '5%', hidden:true },
    { text: 'Employee Code', datafield: 'EmpCode', width: '10%' },
    { text: 'Name', datafield: 'FullName', width: '70%' },
    { text: 'Branch', datafield: 'BranchName', width: '10%' },
    
  ];

  searchInvoiceSource: any =
  {
    datatype: 'json',
    datafields: [
      { name: 'EmployeeID', type: 'int' },
      { name: 'EmpCode', type: 'string' },
      { name: 'FullName', type: 'string' },
      { name: 'BranchName', type: 'string' },
      
    ],
    id: 'invoiceid',
    localdata: ''
  };
  getGridData() {
    this.getData().then((list: any) => {
      this.searchInvoiceSource.localdata = list.result;
      this.searchInvoiceAdapter = new jqx.dataAdapter(this.searchInvoiceSource);
    });

  }
  getData(){
    return new Promise((resolve, reject) => {
      this.httpRequestService.get(this.property.WebAPIipAndPort.concat(this.property.BSSAPI) +"/HR/LOV_EmployeeMaster")
        .then((res: any) => {
          console.log('Response', res);
          if (res.status == 200) {
            resolve(res);
          }
        }, (error) => {
          reject(error);
        });
    });
  }

  RowclickInvoiceSearch(event: any): void {
    var args = event.args;
    var selectedRowIndex = args.rowindex;
    this.searchItem.emit();
    args.row.bounddata.timestamp = new Date().getTime();
    console.log(args);
    this.router.navigate(['home/addasset'], { queryParams: args.row.bounddata });

  }
}
